import { createFeatureSelector } from '@ngrx/store';

export const conversationalChatStoreSelectorKey = 'conversationalChat';

export interface ConversationalChatState {
  conversationalChatSessionId: string | null;
}

export const initialConversationalChatState: ConversationalChatState = {
  conversationalChatSessionId: null,
};

export const selectConversationalChatState =
  createFeatureSelector<ConversationalChatState>(
    conversationalChatStoreSelectorKey
  );
